require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-a-critique-of-the-world-banks-2012-gender-report.json") })
        }
      }, "path---en-us-update-a-critique-of-the-world-banks-2012-gender-report");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-a-critique-of-the-world-banks-2012-gender-report!./.cache/json/en-us-update-a-critique-of-the-world-banks-2012-gender-report.json
// module id = 602
// module chunks = 231608221292675